module.exports = __webpack_public_path__ + "static/media/entry exam.94289179.svg";